import React, { useState } from 'react';
import { Box, Flex, HStack, IconButton, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { expertsGallery } from '../data/gallery';
const MotionBox = motion(Box);
export function TeamCarousel() {
  const [active, setActive] = useState(0);
  const total = expertsGallery.length;
  const go = (direction: 1 | -1) => {
    setActive(current => (current + direction + total) % total);
  };
  return <Box data-id="element-196" data-mp="1jbf7gtt8lini">
      <Box position="relative" h={{
      base: '20rem',
      md: '28rem'
    }} overflow="hidden" role="group" aria-roledescription="carrusel" aria-label="Altares y espacios de trabajo del equipo" data-id="element-197" data-mp="1jc84v46b2vsz">
        {expertsGallery.map((item, index) => {
        let offset = index - active;
        if (offset > total / 2) offset -= total;
        if (offset < -total / 2) offset += total;
        const isActive = offset === 0;
        return <MotionBox key={item.src} position="absolute" top="50%" left="50%" w={{
          base: '78%',
          md: '52%'
        }} h={{
          base: '88%',
          md: '92%'
        }} overflow="hidden" border="1px solid" borderColor={isActive ? 'gold.400' : 'rgba(242,183,5,0.25)'} sx={{
          clipPath: 'polygon(0 0, 100% 0, 100% 90%, 90% 100%, 0 100%)'
        }} animate={{
          x: `calc(-50% + ${offset * 58}%)`,
          y: '-50%',
          scale: isActive ? 1 : 0.78,
          opacity: Math.abs(offset) > 1 ? 0 : isActive ? 1 : 0.55,
          filter: isActive ? 'blur(0px)' : 'blur(4px)',
          zIndex: isActive ? 3 : 1
        }} transition={{
          type: 'spring',
          stiffness: 120,
          damping: 20
        }} data-id="element-198" data-mp="17zjir656rocp" data-mpi={index}>
              <Box as="img" src={item.src} alt={item.alt} loading="lazy" w="100%" h="100%" objectFit="cover" data-id="element-199" data-mp="25fyznqny79n9" />
              <Box position="absolute" inset={0} bg="linear-gradient(180deg, rgba(13,13,13,0) 45%, rgba(13,13,13,0.9) 100%)" aria-hidden="true" data-id="element-200" data-mp="2hgowbfbt22nk" />
              <Text position="absolute" bottom={5} left={5} right={5} fontSize={{
            base: 'sm',
            md: 'md'
          }} fontWeight={600} color="gold.300" data-id="element-201" data-mp="2re3epkhah1ii">
                {item.caption}
              </Text>
            </MotionBox>;
      })}
      </Box>

      <Flex justify="center" mt={6} data-id="element-202" data-mp="28i3jm0t0lhup">
        <HStack spacing={3} data-id="element-203" data-mp="28j4y6f98omh6">
          <IconButton aria-label="Anterior" icon={<ChevronLeftIcon size={20} data-id="element-205" data-mp="1b03hih9tvpyy" />} onClick={() => go(-1)} variant="goldOutline" borderRadius="full" size="lg" data-id="element-204" data-mp="1b2fyar3unuaf" />
          <HStack spacing={2} px={2} data-id="element-206" data-mp="18gzv3qwncpln">
            {expertsGallery.map((item, index) => <Box key={item.src} as="button" type="button" aria-label={`Ver imagen ${index + 1}`} onClick={() => setActive(index)} w={index === active ? '1.75rem' : '0.5rem'} h="0.5rem" borderRadius="full" bg={index === active ? 'gold.400' : 'rgba(250,243,232,0.3)'} transition="all 0.3s ease" data-id="element-207" data-mp="13iya30fnug7j" data-mpi={index} />)}
          </HStack>
          <IconButton aria-label="Siguiente" icon={<ChevronRightIcon size={20} data-id="element-209" data-mp="auiwmic6g5yb" />} onClick={() => go(1)} variant="goldOutline" borderRadius="full" size="lg" data-id="element-208" data-mp="ftc9q9njxuxy" />
        </HStack>
      </Flex>
    </Box>;
}